import React from "react";

const SearchLocationLoader = () => (
  <svg width="40" height="10" viewBox="0 0 20 10" xmlns="http://www.w3.org/2000/svg" fill="#8d959d">
    <circle cx="5" cy="5" r="2">
        <animate attributeName="cy" from="5" to="5"
                 begin="0s" dur="1.5s"
                 values="2;8;8;8;2" calcMode="linear"
                 repeatCount="indefinite" />
    </circle>
    <circle cx="10" cy="5" r="2">
        <animate attributeName="cy" from="5" to="5"
                 begin="0s" dur="1.5s"
                 values="8;2;8;8;8" calcMode="linear"
                 repeatCount="indefinite" />
    </circle>
    <circle cx="15" cy="5" r="2">
        <animate attributeName="cy" from="5" to="5"
                 begin="0s" dur="1.5s"
                 values="8;8;2;8;8" calcMode="linear"
                 repeatCount="indefinite" />
    </circle>
  </svg>
);

export default SearchLocationLoader;
